"use strict";

exports.__esModule = true;
exports.PlantInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _PlantInfoLoader = require("./PlantInfoLoader");
var _TimeContext = require("../../Time/TimeContext");
var _UserListContext = require("../../User/UserListContext");
var _Device = require("../../Device");
var _PlantStateActivitiesContext = require("../../PlantStateActivities/PlantStateActivitiesContext");
var _TicketingContext = require("../../Ticketing/TicketingContext");
var _AlertsContext = require("../../Alerts/AlertsContext");
var _TicketTypeListContext = require("../../TicketTypes/TicketTypeListContext");
var _DeviceTypeListContext = require("../../Device/DeviceTypeListContext");
var _PlantTwinContext = require("../../PlantTwin/PlantTwinContext");
var _PlantStateActivitiesDevicesContext = require("../../PlantStateActivities/PlantStateActivitiesDevicesContext");
var _PredefinedComments = require("../../PredefinedComments");
var _AuditLog = require("../../AuditLog");
var _HistoricalPartCountContext = require("../../HistoricalPartCount/HistoricalPartCountContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PlantInfoProvider(props) {
  return /*#__PURE__*/_react["default"].createElement(_PlantInfoLoader.PlantInfoLoader, null, function (_ref) {
    var time = _ref.time,
      deviceTags = _ref.deviceTags,
      devices = _ref.devices,
      plantStateActivities = _ref.plantStateActivities,
      plantStateActivitiesDevices = _ref.plantStateActivitiesDevices,
      userList = _ref.userList,
      ticketTypes = _ref.ticketTypes,
      deviceTypes = _ref.deviceTypes,
      allDevices = _ref.allDevices,
      allEnabledDevices = _ref.allEnabledDevices,
      plantTwin = _ref.plantTwin;
    return /*#__PURE__*/_react["default"].createElement(_TimeContext.TimeContext.Provider, {
      value: time
    }, /*#__PURE__*/_react["default"].createElement(_Device.DeviceTagListContext.Provider, {
      value: deviceTags
    }, /*#__PURE__*/_react["default"].createElement(_Device.DeviceListContext.Provider, {
      value: devices
    }, /*#__PURE__*/_react["default"].createElement(_Device.AllDeviceListContext.Provider, {
      value: allDevices
    }, /*#__PURE__*/_react["default"].createElement(_Device.AllEnabledDeviceListContext.Provider, {
      value: allEnabledDevices
    }, /*#__PURE__*/_react["default"].createElement(_DeviceTypeListContext.DeviceTypeListContext.Provider, {
      value: deviceTypes
    }, /*#__PURE__*/_react["default"].createElement(_PlantTwinContext.PlantTwinContext.Provider, {
      value: plantTwin
    }, /*#__PURE__*/_react["default"].createElement(_UserListContext.UserListContext.Provider, {
      users: userList
    }, /*#__PURE__*/_react["default"].createElement(_TicketTypeListContext.TicketTypeListContext.Provider, {
      ticketTypes: ticketTypes
    }, /*#__PURE__*/_react["default"].createElement(_TicketingContext.TicketingContext.Provider, null, /*#__PURE__*/_react["default"].createElement(_AlertsContext.AlertsContext.Provider, null, /*#__PURE__*/_react["default"].createElement(_AuditLog.AuditLogContext.Provider, null, /*#__PURE__*/_react["default"].createElement(_HistoricalPartCountContext.HistoricalPartCountContext.Provider, null, /*#__PURE__*/_react["default"].createElement(_PredefinedComments.PredefinedCommentsContext.Provider, null, /*#__PURE__*/_react["default"].createElement(_PlantStateActivitiesContext.PlantStateActivitiesContext.Provider, {
      plantStateActivities: plantStateActivities
    }, /*#__PURE__*/_react["default"].createElement(_PlantStateActivitiesDevicesContext.PlantStateActivitiesDevicesContext.Provider, _extends({
      plantStateActivitiesDevices: plantStateActivitiesDevices
    }, props)))))))))))))))));
  });
}
function PlantInfoConsumer(_ref2) {
  var children = _ref2.children;
  var time = _react["default"].useContext(_TimeContext.TimeContext);
  var devices = _react["default"].useContext(_Device.DeviceListContext);
  var allDevices = _react["default"].useContext(_Device.AllDeviceListContext);
  var allEnabledDevices = _react["default"].useContext(_Device.AllEnabledDeviceListContext);
  var deviceTags = _react["default"].useContext(_Device.DeviceTagListContext);
  var deviceTypes = _react["default"].useContext(_DeviceTypeListContext.DeviceTypeListContext);
  var plantTwin = _react["default"].useContext(_PlantTwinContext.PlantTwinContext);
  var userList = _react["default"].useContext(_UserListContext.UserListContext);
  var ticketTypes = _react["default"].useContext(_TicketTypeListContext.TicketTypeListContext);
  var plantStateActivities = _react["default"].useContext(_PlantStateActivitiesContext.PlantStateActivitiesContext);
  var plantStateActivitiesDevices = _react["default"].useContext(_PlantStateActivitiesDevicesContext.PlantStateActivitiesDevicesContext);
  return children({
    time: time,
    deviceTags: deviceTags,
    devices: devices,
    plantTwin: plantTwin,
    plantStateActivities: plantStateActivities,
    plantStateActivitiesDevices: plantStateActivitiesDevices,
    userList: userList,
    ticketTypes: ticketTypes,
    deviceTypes: deviceTypes,
    allDevices: allDevices,
    allEnabledDevices: allEnabledDevices
  });
}

/**
 * Provides core information about the plant to consumers.
 * @component
 */
var PlantInfo = exports.PlantInfo = {
  Provider: PlantInfoProvider,
  Consumer: PlantInfoConsumer
};